import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const DownArrow24 = (props: SvgProps) => (
  <Svg width={24} height={25} fill="none" {...props}>
    <Path
      d="M7 10L12 15L17 10"
      stroke={props.color ?? '#0058AD'}
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default DownArrow24;
